export default [
  {
    path: '/official-20250916-main',
    component: () => import('./Page.vue'),
    meta: { title: '提现页面' },
  },
  {
    path: '/official-20250916-income-tax',
    component: () => import('./TaxPage.vue'),
    meta: { title: '提现签约' },
  },
  {
    path: '/official-20250916-gold-exchange',
    component: () => import('./GoldExchangePage.vue'),
    meta: { title: '兑换金币' },
  },
  {
    path: '/official-20250916-income-tax-guide',
    component: () => import('./IncomeTaxGuide.vue'),
    meta: { title: '个税汇算操作指导' },
  },
]
